import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Pipe({name: 'lineBreak'})

export class LineBreakPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) {}

    transform(input: any): String {
        if (!input){ 
            return input;
        }
        const formatted = input
        .replaceAll('<', '')
        .replaceAll('>', '')
        .replace(/(\r\n|\n|\r)/g, '<br/>');
        const transformedContent = this.sanitizer.sanitize(SecurityContext.HTML, formatted || '')
        return transformedContent || '';
    }
}
